export default class DtoQualification {
    constructor(object) {
        this.code = object.code
        this.name = object.name
    }
}
